import { defaultTo, split } from 'lodash';

import { safeJsonParse } from '@/utils/parsing';

type AppConfig = {
  routerBaseUrl?: string;
  bugsnagApiKey?: string;
  bugsnagEnabled: boolean;
  bugsnagReleaseStage?: string;
  bugsnagEnabledReleaseStages?: string[]
  logLevel?: string;
  oidcProviderUrl?: string;
  oidcClientId?: string;
  port?: number;
  env: string;
  isDev: boolean;
}

const rc = () => (typeof window !== 'undefined' ? window.__config__ : undefined) ?? {};

export const getAppConfig = (): AppConfig => ({
  routerBaseUrl: import.meta.env.VITE_ROUTER_BASE_URL,
  bugsnagApiKey: rc().BUGSNAG_API_KEY ?? import.meta.env.VITE_BUGSNAG_API_KEY,
  bugsnagEnabled: Boolean(safeJsonParse<boolean>(rc().BUGSNAG_ENABLED ?? import.meta.env.VITE_BUGSNAG_ENABLED)),
  bugsnagReleaseStage: rc().BUGSNAG_RELEASE_STAGE ?? import.meta.env.VITE_BUGSNAG_RELEASE_STAGE,
  bugsnagEnabledReleaseStages: import.meta.env.VITE_BUGSNAG_ENABLED_RELEASE_STAGES
    ? split(import.meta.env.VITE_BUGSNAG_ENABLED_RELEASE_STAGES, ' ')
    : undefined,
  logLevel: rc().LOG_LEVEL ?? import.meta.env.VITE_LOG_LEVEL,
  oidcClientId: rc().OIDC_CLIENT_ID ?? import.meta.env.VITE_OIDC_CLIENT_ID,
  oidcProviderUrl: rc().OIDC_PROVIDER_URL ?? import.meta.env.VITE_OIDC_PROVIDER_URL,
  port: defaultTo(safeJsonParse<number>(import.meta.env.VITE_PORT), undefined),
  // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  env: process.env.NODE_ENV,
  isDev: process.env.NODE_ENV !== 'production',
});
